import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import "react-big-calendar/lib/css/react-big-calendar.css";
import { useSelector } from "react-redux";
import moment from "moment";
import "moment-timezone";
import { toast } from "react-toastify";
import {
  deleteSheduleAppointments,
  editSheduleAppointments,
} from "../../services/sheduleAppointmentsServices";
import DeleteIcon from "@mui/icons-material/Delete";

const MentorCalendar = ({ schedule }) => {
  const mentorTimezone =
    useSelector((s) => s.mentor?.profile?.timezone) || moment.tz.guess();
  const mentorId = useSelector((s) => s.mentor?.profile?.userId);

  const [events, setEvents] = useState([]);
  const [view, setView] = useState("month");
  const [selectedDate, setSelectedDate] = useState(new Date());

  const localizer = momentLocalizer(moment);

  useEffect(() => {
    moment.tz.setDefault(mentorTimezone);
  }, [mentorTimezone]);

  useEffect(() => {
    const transformedEvents = schedule.map((slot) => {
      const startMoment = moment.utc(slot.startTime).tz(mentorTimezone);
      const endMoment = moment.utc(slot.endTime).tz(mentorTimezone);

      const is1145toMidnight =
        startMoment.format("hh:mm A") === "11:45 PM" &&
        endMoment.format("hh:mm A") === "12:00 AM";

      if (is1145toMidnight) {
        const adjustedEnd = startMoment.clone().add(14, "minutes");
        return {
          title: "Available Slot",
          start: startMoment.toDate(),
          end: adjustedEnd.toDate(),
        };
      }

      return {
        title: "Available Slot",
        start: startMoment.toDate(),
        end: endMoment.toDate(),
      };
    });

    setEvents(transformedEvents);
  }, [schedule, mentorTimezone]);

  const handleSelectSlot = async (slotInfo) => {
    // Month view click → switch to day view
    if (view === "month") {
      setView("day");
      setSelectedDate(slotInfo.start);
      return;
    }

    let selectedStart = moment(slotInfo.start).tz(mentorTimezone, true);
    const now = moment().tz(mentorTimezone);
    const selectedDate = selectedStart.clone().startOf("day");
    const today = now.clone().startOf("day");

    if (selectedDate.isBefore(today)) {
      toast.error("You cannot select a slot on a past date.");
      return;
    }

    if (selectedDate.isSame(today, "day") && selectedStart.isBefore(now)) {
      toast.error("You cannot select a past time slot for today.");
      return;
    }

    selectedStart = moment(slotInfo.start).tz(mentorTimezone, true).utc();
    let selectedEnd;
    const timeOnly = moment(slotInfo.start).format("HH:mm");
    if (timeOnly === "23:45") {
      selectedEnd = selectedStart.clone().add(14, "minutes");
    } else {
      selectedEnd = selectedStart.clone().add(15, "minutes");
    }

    const existingEventIndex = events.findIndex(
      (event) =>
        moment(event.start).isSame(selectedStart.toDate()) &&
        moment(event.end).isSame(selectedEnd.toDate())
    );

    if (existingEventIndex !== -1) {
      setEvents(events.filter((_, index) => index !== existingEventIndex));
    } else {
      const newEvent = {
        title: "Available Slot",
        start: selectedStart.toDate(),
        end: selectedEnd.toDate(),
      };
      setEvents((prevEvents) => [...prevEvents, newEvent]);
    }

    await editSheduleAppointments({
      userId: mentorId,
      startTime: selectedStart.format("YYYY-MM-DD HH:mm:ss z"),
      endTime: selectedEnd.format("YYYY-MM-DD HH:mm:ss z"),
    });
  };

  const handleEventClick = async (event) => {
    setEvents((prevEvents) =>
      prevEvents.filter(
        (e) =>
          moment(e.start).valueOf() !== moment(event.start).valueOf() ||
          moment(e.end).valueOf() !== moment(event.end).valueOf()
      )
    );
    const selectedStart = moment(event.start).tz(mentorTimezone, true).utc();
    const selectedEnd = selectedStart.clone().add(15, "minutes");

    await deleteSheduleAppointments({
      userId: mentorId,
      startTime: selectedStart.format("YYYY-MM-DD HH:mm:ss z"),
      endTime: selectedEnd.format("YYYY-MM-DD HH:mm:ss z"),
    });
  };

  return (
    <div>
      <Calendar
        localizer={localizer}
        events={events.map((event) => ({
          ...event,
          start: moment(event.start).tz(mentorTimezone, true).toDate(),
          end: moment(event.end).tz(mentorTimezone, true).toDate(),
        }))}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 400 }}
        step={15}
        timeslots={1}
        selectable={true}
        view={view}
        date={selectedDate}
        onView={(newView) => setView(newView)}
        onNavigate={(newDate) => setSelectedDate(newDate)}
        onSelectSlot={handleSelectSlot}
        views={["month", "day"]}
        components={{
          event: ({ event }) => (
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "4px 8px",
              }}
            >
              <span>{event.title}</span>
              <button
                onClick={(e) => {
                  e.stopPropagation();
                  handleEventClick(event);
                }}
                style={{
                  marginLeft: "15px",
                  marginRight: "138px",
                  border: "none",
                  borderRadius: "1px",
                  color: "#F44336",
                  cursor: "pointer",
                  padding: "2px 6px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
                aria-label="Delete slot"
              >
                <DeleteIcon style={{ fontSize: "1.2rem" }} />
              </button>
            </div>
          ),
        }}
      />
    </div>
  );
};

export default MentorCalendar;
